<template>
    <v-dialog
      v-model="isSuccessed"
      persistent
      max-width="500"
    >
      <v-card align-center>
         <v-card-text class="text-center">
            <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
            <p v-html="successText"></p>
        </v-card-text>
        <v-card-actions class="px-8">
          <v-btn
            color="teal darken-1"
            rounded
            block
            @click="showDialog()"
            class="white--text mb-5"
          >
            お申込みページに戻る
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:["successUrl","successText"],
    data: () => ({
        isSuccessed: false,
        id: "",
        hasHazardousMaterials: false
    }),
    methods: {
      showDialog() {
          this.isSuccessed = false
//          this.$router.back()
          this.$router.push(this.successUrl)
      },
      open(ifjson) {
        console.log('result from modal:', ifjson)
        this.id = ifjson.id
        this.hasHazardousMaterials = ifjson.hasHazardousMaterials
        
        this.isSuccessed = true
      }
    }
}
</script>

